"use strict";
/*
 * Created on 05 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Converter of {@link SelloutReleaseItemEvaluation}.
 *
 * @author JMe
 */


var SelloutReleaseItemEvaluationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseItemEvaluationConverter, _DataObjectConverter_);

  function SelloutReleaseItemEvaluationConverter() {
    _classCallCheck(this, SelloutReleaseItemEvaluationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemEvaluationConverter).apply(this, arguments));
  }

  return SelloutReleaseItemEvaluationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseItemEvaluationConverter = SelloutReleaseItemEvaluationConverter;